<template>
  <div class="">
    <Navbar />

    <div id="main">
      <div class="container">
        <div class="row align-items-center" style="background:#000;">
          <div class="col-md-12 px-0 py-0" v-lazy-container="{ selector: 'img' }">
            <img data-src="/logo/imgpage.jpg" data-loading="/logo/imgpage.jpg"
              style="width:100%;max-height:495px;object-fit:cover;">
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" style="min-height:200px; background: linear-gradient(#1b1b1b, #4e4e4e); color:#fff;">
            <div class="text-center mb-4">
              <h2 class="py-2" style="color:#fff;">We are Accepting New Voice Talent</h2>
            </div>
            <div class="text-center" style="line-height: 1.8em; align:justify;">
              <small>Are you interested in working in the voiceover industry or seeking more voice work
                opportunities?</small>
              <br><br>
              <small>IDIOM Talent is a voiceover and commercial talent agency headquartered in Hollywood, California,
                with
                regional offices in Asia. We are constantly on the lookout for both up-and-coming and professional voice
                talent to work on a variety of projects, including commercials, narration, audiobooks, feature
                animation,
                video games, television series, and more.</small>
              <br><br>
              <small>We are seeking new voices as well as experienced talent who can deliver competitive auditions from
                home. Our agency receives some of the best voice projects the industry has to offer, including exclusive
                international opportunities.</small>
              <br><br>
              <h6 class="mb-0">
                If you have what it takes to stand out from the competition or bring something unique to the table, we'd
                love to hear from you.
                <br><br>
                Download information on how to record and submit your voiceover audition, or upload your own demo below.
                <br>
                <a class="btn btn-idiom btn-round btn-sm mt-3" href="pdf/IDIOM_Submission_Form_2021.pdf"
                  target="_blank">CLICK HERE</a>
              </h6>
              <!-- <div class="mt-5">
                <a href="https://play.google.com/store/apps/details?id=com.idiomtalent.audition" target="_blank">
                  <font color="white">
                    <p>Want to Audition Later? </p>
                    <img src="/logo/play_store.png" alt="">
                    <br><br>
                    <p>Idiom Talent Agency Audition Recorder</p>
                  </font>
                </a>
              </div> -->
            </div>

            <!-- <Testimonial /> -->

            <form class="row mb-5" @submit.prevent="submitForm">
              <div class="col-12 text-center my-4">
                <h3>Your Information</h3>
              </div>
              <div class="col-12">
                <div class="form-row">
                  <div class="form-group col-lg-4 col-md-6">
                    <label>First Name </label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="First Name" v-model="name"
                        :disabled="processing" required>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Last Name </label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="Last Name" v-model="lastname"
                        :disabled="processing" required>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Gender </label>
                    <div :class="{ 'control is-loading': processing }">
                      <select class="form-control" v-model="gender" :disabled="processing" required>
                        <option value="" selected disabled>Select Gender</option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Email </label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="email" class="form-control" placeholder="Email" v-model="email"
                        :disabled="processing" required>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>State </label>
                    <div :class="{ 'control is-loading': processing }">
                      <select class="form-control" v-model="states_str" :disabled="processing" required>
                        <option value="" selected disabled>Select State</option>
                        <option v-for="(val, key) in states" :key="key" :value="val">{{ val }}</option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="form-group col-lg-4 col-md-6">
                    <label>City </label>
                    <div :class="{'control is-loading':processing}">
                      <select class="form-control" v-model="city_str" :disabled="processing" required>
                        <option value="" selected disabled>Select City</option>
                        <option v-for="(val,key) in cities" :key="key" :value="val.name">{{val.name}}</option>
                      </select>
                    </div>
                  </div> -->
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Country </label>
                    <div :class="{ 'control is-loading': processing }">
                      <select class="form-control" v-model="country_id" :disabled="processing" required>
                        <option value="" selected disabled>Select Country</option>
                        <option v-for="(val, key) in countries" :key="key" :value="val.id">{{ val.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Age Range </label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="age_range_str" v-model="age_range_str" :options="age_range"
                        placeholder="Age Range..." label="name" track-by="id" :multiple="true" :disabled="processing">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Language </label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="language_str" v-model="language_str" :options="languages"
                        placeholder="Languages..." label="name" track-by="id" :multiple="true" :disabled="processing">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Ethnicity </label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="ethnicity_str" v-model="ethnicity_str" :options="ethnicities"
                        placeholder="Ethnicities..." label="name" track-by="id" :multiple="true" :disabled="processing">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Union Status </label>
                    <div :class="{ 'control is-loading': processing }">
                      <multiselect ref="union_status_str" v-model="union_status_str" :options="union_status"
                        placeholder="(If unsure, Select non-union)" label="name" track-by="id" :multiple="true"
                        :disabled="processing"></multiselect>
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Phone Number</label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="Phone Number" v-model="phone"
                        :disabled="processing">
                    </div>
                  </div>
                  <div class="form-group col-lg-4 col-md-6">
                    <label>Additional Information</label>
                    <div :class="{ 'control is-loading': processing }">
                      <input type="text" class="form-control" placeholder="(Links to material in place of files)"
                        v-model="detail" :disabled="processing">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center my-4">
                <label class="pr-2">Upload Demo File(s) </label>
                <button type="button" class="btn btn-idiom" @click="showAddDemo = true"
                  :class="{ 'button is-loading': processing }">Add Demo</button>
                <ul class="list-group mx-auto mt-3" style="width:250px;" v-if="demo_files.length">
                  <li class="list-group-item list-group-item-info" v-for="(val, key) in demo_files" :key="key">
                    <a href="#" target="_blank" @click="previewDemo(val)">
                      <i class="far fa-file-audio"></i> Preview
                    </a>
                    Demo File
                  </li>
                </ul>
              </div>
              <div class="col-12 text-center my-4">
                <button type="submit" class="btn btn-idiom btn-round"
                  :class="{ 'button is-loading': processing }">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>

    <div class="modal" :class="{ 'is-active': showAddDemo }">
      <div class="modal-background"></div>
      <!-- @click="showAddDemo=false" -->
      <form class="modal-card" @submit.prevent="processFormAddDemo">
        <header class="modal-card-head">
          <p class="modal-card-title">Add Demo(s)</p>
          <button class="delete" @click="showAddDemo = false"></button>
        </header>
        <section class="modal-card-body">
          <div class="row">
            <label id="label_select_file" class="col-md-3">Select File</label>
            <div class="col-sm-7" :class="{ 'control is-loading': uploading }">
              <input type="file" ref="file" class="form-control form-control-sm" accept="audio/*" style="height:37px;"
                :disabled="uploading" required>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot row">
          <div class="col text-right">
            <button type="button" class="button" @click="showAddDemo = false"
              :class="{ 'button is-loading': uploading }">Close</button>
            <button type="submit" class="button is-info" :class="{ 'button is-loading': uploading }">Upload</button>
          </div>
        </footer>
      </form>
      <button class="modal-close is-large" aria-label="close" @click="showAddDemo = false"></button>
    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
// import Testimonial from '@/components/Testimonial.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'Submit',
  components: { Navbar, Footer, /*Testimonial,*/ Multiselect },
  data() {
    return {
      name: "",
      lastname: "",
      gender: "",
      email: "",
      states_str: "",
      city_str: "",
      country_id: "",
      age_range_str: [],
      language_str: [],
      ethnicity_str: [],
      union_status_str: [],
      phone: "",
      detail: "",
      demo_files: [
        // {"category_ref_id":0,"name":"5fa118b27d65b_jTj2DiILvA.mp3","file_name":"5fa118b27d65b_jTj2DiILvA.mp3","ref_id":"0","file_image_id_ref":0,"media_type":2,"file_size":"2.98 MB","publish":0,"group_type":0,"enable":1,"update_time":"2020-11-03 09:45:38","create_time":"2020-11-03 09:45:38","id":6,"category_name":null}
      ],
      showAddDemo: false,
      uploading: false,
      processing: false,
      // ................
      cities: [],
      countries: [],
      age_range: [],
      languages: [],
      ethnicities: [],
      union_status: [
        { id: 1, name: 'Sag/Aftra' },
        { id: 2, name: 'Non-Union' },
        { id: 3, name: 'Fi-Core' },
        { id: 4, name: 'Eligible' },
        { id: 5, name: 'Must-Join' },
      ],
      states: [
        "International",
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Indiana", "Illinois", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri",
        "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Rhode Island", "Pennsylvania", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
        "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
      ]
    }
  },
  created() {
    this.cities = this.LocalStorage("_IdiomtalentDataCities", new Array());
    this.countries = this.LocalStorage("_IdiomtalentDataCountries", new Array());
    this.age_range = this.LocalStorage("_IdiomtalentDataAgeRange", new Array());
    this.languages = this.LocalStorage("_IdiomtalentDataLanguages", new Array());
    this.ethnicities = this.LocalStorage("_IdiomtalentDataEthnicities", new Array());
  },
  mounted() {
    if (!this.cities.length) {
      this.get_cities();
    } else {
      this.add_not_on_list_cities();
    }
    if (!this.countries.length) this.get_countries();
    if (!this.age_range.length) this.get_age_range();
    if (!this.languages.length) this.get_languages();
    if (!this.ethnicities.length) this.get_ethnicities();
  },
  methods: {
    add_not_on_list_cities() {
      const NOT_ON_LIST = { id: 0, name: "Not on list", enable: 1 };
      // this.cities.push(NOT_ON_LIST);
      this.cities.unshift(NOT_ON_LIST);
    },
    async get_cities() {
      var url = this.api + 'dataOption/get_cities/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.cities = response.data.data;
            localStorage.setItem("_IdiomtalentDataCities", JSON.stringify(response.data.data));
            //
            //
            this.add_not_on_list_cities()
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_countries() {
      var url = this.api + 'dataOption/get_countries/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.countries = response.data.data;
            localStorage.setItem("_IdiomtalentDataCountries", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_age_range() {
      var url = this.api + 'dataOption/get_age_range/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.age_range = response.data.data;
            localStorage.setItem("_IdiomtalentDataAgeRange", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_languages() {
      var url = this.api + 'dataOption/get_languages/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.languages = response.data.data;
            localStorage.setItem("_IdiomtalentDataLanguages", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async get_ethnicities() {
      var url = this.api + 'dataOption/get_ethnicities/' + this.secret;
      var data = new FormData();
      data.set('secret', this.secret);
      await this.Axios.post(url, data)
        .then((response) => {
          if (response.data.error == 0) {
            this.ethnicities = response.data.data;
            localStorage.setItem("_IdiomtalentDataEthnicities", JSON.stringify(response.data.data));
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
    },
    async processFormAddDemo() {
      if (this.uploading) return false;

      this.uploading = true;
      var url = this.api + 'MediaFile/upload_demo/' + this.secret;
      let data = new FormData();
      data.append('file', this.$refs.file.files[0]);
      data.set('id', 0);
      await this.Axios.post(url, data)
        .then((response) => {
          console.log(response.data);
          if (response.data.error == 0) {
            this.demo_files.push(response.data.audio);
            this.showAddDemo = false;
          }
        })
        .catch((error) => {
          alert(error);
          console.error(error);
        })
        .then(() => {
          this.uploading = false;
        })
    },
    previewDemo(val) {
      let demo_url = this.idiom + "source/audio/" + val.file_name;
      window.open(demo_url, 'PreviewDemo', 'width=400,height=400')
    },
    async submitForm() {
      if (this.processing) return false;

      switch (true) {
        case (!this.age_range_str.length):
          this.$refs.age_range_str.$el.focus()
          return false;
        case (!this.language_str.length):
          this.$refs.language_str.$el.focus()
          return false;
        // case (!this.ethnicity_str.length):
        //   this.$refs.ethnicity_str.$el.focus()
        //   return false;
        case (!this.union_status_str.length):
          this.$refs.union_status_str.$el.focus()
          return false;
        case (!this.demo_files.length):
          this.$swal("Required Demo!", "Minimum require 1 demo file!", "warning");
          return false;
        default:
          this.processing = true;
      }
      // return false;

      var url = this.api + 'user/submit_new_profile/' + this.secret;
      var data = new FormData();
      data.set('name', this.name);
      data.set('lastname', this.lastname);
      data.set('gender', this.gender);
      data.set('email', this.email);
      data.set('states_str', this.states_str);
      // data.set('city_str',this.city_str );
      data.set('country_id', this.country_id);
      data.set('age_range_str', JSON.stringify(this.age_range_str.map((e) => e.id)));
      data.set('language_str', JSON.stringify(this.language_str.map((e) => e.name)));
      data.set('ethnicity_str', JSON.stringify(this.ethnicity_str.map((e) => e.name)));
      data.set('union_status_str', JSON.stringify(this.union_status_str.map((e) => e.name)));
      data.set('phone', this.phone);
      data.set('detail', this.detail);
      data.set('audio_id', JSON.stringify(this.demo_files.map((e) => e.id)));
      await this.Axios.post(url, data)
        .then((response) => {
          // console.log(response.data);
          if (response.data.error == 0) {
            this.name = "";
            this.lastname = "";
            this.gender = "";
            this.email = "";
            this.city_str = "";
            this.country_id = "";
            this.age_range_str = [];
            this.language_str = [];
            this.ethnicity_str = [];
            this.union_status_str = [];
            this.phone = "";
            this.detail = "";
            this.demo_files = [];
            this.$swal("Success!", response.data.data, "success");
          } else {
            this.$swal("Error!", response.data.data, "success");
          }
        })
        .catch((error) => {
          this.$swal("", "", "warning");
          console.error(error);
        })
        .then(() => {
          this.processing = false;
        })
    }
  },
  watch: {
    showAddDemo(val) {
      if (!val) {
        this.uploading = false;
        this.$refs.file.value = null;
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#top h2 {
  text-align: right;
}

#detail {
  padding: 50px;
  width: 100% !important;
}

#detail small {
  font-size: 16px;
}

#label_select_file {
  padding-top: 9px;
  text-align: right;
}

@media (max-width: 600px) {
  #top h2 {
    text-align: center;
    font-size: 22px;
  }

  #detail h2 {
    font-size: 18px;
  }

  #detail small {
    font-size: 14px;
  }

  #detail {
    padding: 25px;
  }

  #label_select_file {
    text-align: left;
  }
}
</style>
